import { render, staticRenderFns } from "./BarExamensCompByTypesExamenChart.vue?vue&type=template&id=8a5eb66e&"
import script from "./BarExamensCompByTypesExamenChart.vue?vue&type=script&lang=ts&"
export * from "./BarExamensCompByTypesExamenChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports